jQuery(document).ready(function ($) {
	$(".EVENT-PAGE__info__element").on("click", function () {
		$(".EVENT-PAGE__info__element")
			.removeClass("EVENT-PAGE__info__element--open")
			.children(".EVENT-PAGE__info__dropdown")
			.removeClass("EVENT-PAGE__info__dropdown--open");
		$(this)
			.addClass("EVENT-PAGE__info__element--open")
			.children(".EVENT-PAGE__info__dropdown")
			.addClass("EVENT-PAGE__info__dropdown--open");
	});
});
